const ClipboardCross = ( props ) => {
    const pathStroke = props.stroke || 'black';

    const styleB = {
        fill: pathStroke,
        stroke: pathStroke,
        strokeWidth: 6.23,
    }

    const styleC = {
        fill: '#fff',
        stroke: pathStroke,
        strokeMiterlimit: 10,
        strokeWidth: 24.92,
    }

    return (
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path style={styleB} d="M635.53,353.73h-61.39v-22.68c0-4.44-3.6-8.05-8.05-8.05h-43.55c-6.02-14.74-20.36-24.57-36.86-24.57s-30.85,9.82-36.8,24.57h-43.6c-4.45,0-8.05,3.61-8.05,8.05v22.68h-61.39c-20.97,0-38.02,17.06-38.02,38.02v351.81c0,20.96,17.06,38.02,38.02,38.02h299.7c20.97,0,38.02-17.06,38.02-38.02v-351.81c0-20.96-17.06-38.02-38.02-38.02ZM454.78,339.1c3.78,0,7.05-2.63,7.87-6.31,2.34-10.57,12.03-18.25,23.03-18.25s20.67,7.53,23.12,18.3c.84,3.66,4.1,6.26,7.86,6.26h41.38v40.41h-144.71v-40.4h41.45ZM657.45,743.57c0,12.08-9.83,21.91-21.92,21.91h-299.7c-12.09,0-21.92-9.83-21.92-21.91v-351.82c0-12.08,9.83-21.91,21.92-21.91h61.37v17.72c0,2.23.91,4.25,2.38,5.71,1.46,1.46,3.47,2.37,5.7,2.37h160.82c2.23,0,4.24-.9,5.7-2.37,1.47-1.46,2.38-3.48,2.38-5.71v-17.72h61.37c12.09,0,21.92,9.83,21.92,21.91v351.81h0Z"/>
            <circle style={styleC} cx="680.16" cy="587.3" r="102.03"/>
            <line style={styleC} x1="724.59" y1="542.88" x2="635.74" y2="631.73"/>
            <line style={styleC} x1="635.74" y1="542.88" x2="724.59" y2="631.73"/>
        </svg>
    )
}
export default ClipboardCross